import React, { useState, useEffect } from "react";
import "./HeroStyles.scss";
import ScrollAnimation from "react-animate-on-scroll";
import CourseSignup from "../CourseSignup/CourseSignup";

const Hero = ({ image }) => {
  const [offsetY, setOffsetY] = useState(0);

  const handleScroll = () => setOffsetY(window.pageYOffset / 2);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div style={{ transform: `translateY(${offsetY * 0.5}px)` }}>
      <div className='hero'>
        <img src={image.fields.file.url} alt='oren' />
      </div>
      <div className='hero__overlay'>
        <ScrollAnimation animateIn='bounceInDown' animateOut='fadeOut'>
          <h1>OREN MARSHALL</h1>
          <CourseSignup />
        </ScrollAnimation>
      </div>
    </div>
  );
};

export default Hero;
